import { useDashboard } from '../contexts/DashboardContext';

function formatDate(iso) {
  const d = new Date(iso + 'T00:00:00');
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${d.getDate()} ${months[d.getMonth()]}`;
}

export default function Header({ onLogout }) {
  const { teams, dates, selectedTeam, selectedDate, selectTeam, selectDate, loading } = useDashboard();

  return (
    <nav className="navbar navbar-dark bg-dark flex-shrink-0 py-1">
      <div className="container-fluid px-3">
        <span className="navbar-brand mb-0 small">Outrights Demo</span>
        <div className="d-flex align-items-center gap-2">
          {!loading && teams.length > 0 && (
            <select
              className="form-select form-select-sm bg-dark text-light border-secondary"
              style={{ width: 'auto', maxWidth: '160px' }}
              value={selectedTeam ?? ''}
              onChange={(e) => selectTeam(e.target.value)}
            >
              {teams.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          )}
          {!loading && dates.length > 0 && (
            <select
              className="form-select form-select-sm bg-dark text-light border-secondary"
              style={{ width: 'auto' }}
              value={selectedDate ?? ''}
              onChange={(e) => selectDate(e.target.value)}
            >
              {dates.map((d) => (
                <option key={d} value={d}>{formatDate(d)}</option>
              ))}
            </select>
          )}
          <button onClick={onLogout} className="btn btn-outline-light btn-sm">Logout</button>
        </div>
      </div>
    </nav>
  );
}
